import React from 'react';

const Loading = () => {
    return (
        <div>
            <div className='py-5 text-center fw-bold text-success'>
                <p>LOADING....</p>
            </div>
        </div>
    );
};

export default Loading;